/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { generateGuid } from "utils/empty-exists";

/**
 * @template {{guid: string}} T
 * @param {Readonly<T>} defaultItem 
 * @returns {T}
 */
export const itemWithGuid = (defaultItem) => {

    return {
        guid: generateGuid(),
        ...defaultItem
    };
};
